import axios from 'axios';
import {
    NOTE_GET_ONE,
    NOTE_GET_MULTIPLE,
    NOTE_GET_DROPDOWNS,
    NOTE_REGISTER_SUCCESS,
    NOTE_REGISTER_FAIL,
    NOTE_LOADING,
    NOTE_LOADING_ERROR,
    NOTE_UPDATE_SUCCESS,
    NOTE_UPDATE_FAIL,
    NOTE_DELETE_SUCCESS,
    NOTE_DELETE_FAIL
} from "./../types/note";
import { MAIN_TOKEN, SERVER_PATH, axiosConfig1, axiosConfig } from './common';

let TABLE_NAME = 'notes';
const path = SERVER_PATH;

//GET ALL NOTE 
export const getNotes = params => (dispatch, getState) => {
    //SET PAGE LOADING
    params.token = MAIN_TOKEN;
    params.table = TABLE_NAME;

    dispatch({type : NOTE_LOADING});
        axios.get(path, {params}, axiosConfig)
            .then(res => {                                                                                                                                                                                                                                        
                dispatch({
                    type: NOTE_GET_MULTIPLE,
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({
                    type : NOTE_LOADING_ERROR,
                    payload:err
                })
            })
};
//GET ALL NOTE 
export const getNotedropdowns = params => (dispatch, getState) => {
    //SET PAGE LOADING
    params.token = MAIN_TOKEN;
    params.table = TABLE_NAME;

    dispatch({type : NOTE_LOADING});
        axios.get(path, {params}, axiosConfig)
            .then(res => {                                                                                                                                                                                                                                        
                dispatch({
                    type: NOTE_GET_DROPDOWNS,
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({
                    type : NOTE_LOADING_ERROR,
                    payload:err
                })
            })
};
//GET SINGLE NOTE 
export const getNote = id => (dispatch, getState) => {
    //SET PAGE LOADING
    dispatch(
        {
        type : NOTE_GET_ONE,
        payload: id
    });  
};
//NOTE DELETE
export const deleteNote = params => (dispatch, getState) =>{
    axios.POST(path, {params}, axiosConfig)
        .then(res => {
            dispatch({
                type: NOTE_DELETE_SUCCESS,
                payload: params.id
            })
        })
        .catch(err => {
            dispatch({
                type : NOTE_DELETE_FAIL,
                payload : err
            })
        })
        
}
//NOTE REGISTER
export const registerNote = data => dispatch => {
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: NOTE_REGISTER_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : NOTE_REGISTER_FAIL,
                payload: err
            })
        })
};
 //NOTE UPDATE
export const updateNote = (data) => (dispatch, getState) => {
    //body
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: NOTE_UPDATE_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : NOTE_UPDATE_FAIL,
                payload: err
            })
        })
};
